import { useContext } from 'react';

import { RolesContext } from '@/providers';

function useRoles() {
  return useContext(RolesContext);
}

export default useRoles;
